module.exports = __webpack_public_path__ + "static/img/2.3a77db16.png";